import { UiSchema, WidgetProps } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormImageUpload } from '../shared/dynamic-form-image-upload';
import { DynamicFormMultiselect } from '../shared/dynamic-form-multiselect';

const uiGrid: UIGridElement[] = [
  { fields: { allowedProjectIds: 8, urlSlug: 4 } },
  { fields: { parent: 8, shortcode: 4 } },
  { fields: { logoUrl: 12 } },
  { title: 'Customization', fields: { unitLabel: 4, headerTextColor: 4, bgColor: 4 } },
  { title: 'Overrides', fields: { addressOverride: 12, tncOverride: 12, thankYouOverride: 12 } }
];

export const registrationPageFormUISchema: UiSchema = {
  'ui:submitButtonOptions': {
    norender: true
  },
  allowedProjectIds: {
    'ui:widget': (props: WidgetProps) => {
      return <DynamicFormMultiselect {...props} />;
    }
  },
  addressOverride: {
    'ui:widget': 'textarea'
  },
  tncOverride: {
    'ui:widget': 'textarea'
  },
  thankYouOverride: {
    'ui:widget': 'textarea'
  },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  logoUrl: {
    'ui:widget': (props: WidgetProps) => {
      return <DynamicFormImageUpload {...props} />;
    }
  }
};
